import React, { FunctionComponent, useMemo } from 'react';
import { IThumbnailImage } from './types';

export { IThumbnailImage };

export const ThumbnailImage: FunctionComponent<IThumbnailImage> = ({
    activeThumbnail,
    containerWidth,
    containerHeight,
    style,
}) => (
    null
);
